import React from 'react';
import _ from 'lodash';
import {
  isNotUndefinedAll,
  isArrayAll,
  isFunctionAll,
} from '../../../utilities/parts';

import { DateInput, DateInputYearMonth } from '../../DateInput';
import { WorkerInputText } from '../WorkerInputText.jsx';
import { WorkerRadioText } from '../WorkerRadioText.jsx';
import SafetyDocItemIcon from '../../../components/SafetyDocItemIcon';

import {
  EXISTANCE_EXCLUSION_FLAG,
  EXISTANCE_FLAG,
  WORKER_COMPENSATION_TYPE,
  INSURANCE_RECEIVING_FLAG,
  PENSION_VOLUNTARY_COVERAGE_FLAG,
} from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import {
  getTextExistanceExclusionFlag,
  getTextExistanceFlag,
  getTextInsuranceReceivingFlag,
  getTextWorkerCompensationType,
  getTextPensionVoluntaryCoverageFlag,
} from '../../../utilities/constantsUtil';
import {
  filterComboBoxHealthInsuranceTypeWhenExist,
  filterComboBoxHealthInsuranceTypeWhenExclusion,
} from '../../../utilities/insuranceFormUtil';
import {
  deleteControlCode,
  isNullOrUndefinedOrEmptyStr,
} from '../../../utilities/stringUtil';
import { isDayBeforeXYearsOld } from '../../../utilities/momentUtil';

import AttachDocument from '../../forms/AttachDocument';
import {
  FormList,
  FormListSubHeader,
  FormListItem,
  FormElement,
  FormElementContainer,
  FormElementContainerItem,
} from '../../CommonFormComponents';
import { FormSelect } from '../../FormSelect';
import { CcusTitleBlock, CcusLineComponent } from '../../CcusFormComponent';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import CcusMasterService from '../../../services/CcusMasters';
import { Description } from '../../Description';
import { AdditionalInfoAboutOthers } from '../../AdditionalInfoAboutOthers';
import { InsuranceDocumentMyNumberCardWarning } from '../../InsuranceDocumentAttention';
import { wrapperValidExpirationDate } from '../../../utilities/dateSelectorUtility';

const FormRadio = ({ label, name, events, value, checked, disabled }) => {
  return (
    <div className='form-list-radio__item'>
      <label className='radio'>
        <input
          name={name}
          type='radio'
          checked={checked}
          value={value}
          onChange={e => {
            events.setValueInsuranceInfo(e.target.name, e.target.value);
          }}
          disabled={disabled}
        />
        <RadioButtonIcon className='icon--2x' />
        <span>{label}</span>
      </label>
    </div>
  );
};

/**
 * 作業員編集 画面 > 保険加入状況
 */
const InsuranceInfoForm = ({
  events,
  formValues,
  ccus_info,
  messages,
  disabledAll,
  comboBoxList,
  isCcusJigyousyaDeleted,
  attachDocumentCodes_HealthInsurance, // 健康保険 保険証 選択項目
  attachDocuments_HealthInsurance, // 健康保険 保険証 内容
  attachDocumentCodes_Pension, // 年金 保険証 選択項目
  attachDocuments_Pension, // 年金 保険証 内容
  attachDocumentCodes_EmploymentInsurance, // 雇用保険 保険証 選択項目
  attachDocuments_EmploymentInsurance, // 雇用保険 保険証 内容
  attachDocumentCodes_UnemploymentInsurance, // 退職金共済 保険証 選択項目
  attachDocuments_UnemploymentInsurance, // 退職金共済 保険証 内容
  attachDocumentCodes_WorkerCompensation, // 労災保険特別加入 保険証 選択項目
  attachDocuments_WorkerCompensation, // 労災保険特別加入 保険証 内容,
  downloadWorkerInsuranceManual,
  ccusDescription,
  attentionBox,
  workerBirthday,
  isShowPensionExpirationDate,
  isShowPensionVoluntaryCoverageFlag,
}) => {
  const isDayBeforeTwentiethBirthday = isDayBeforeXYearsOld(workerBirthday, 20);
  const isDayBeforeSixtiethBirthday = isDayBeforeXYearsOld(workerBirthday, 60);

  // console.log('InsuranceInfoForm.jsx messages', messages);
  let healthInsuranceComboBoxList = _.cloneDeep(
    comboBoxList.healthInsuranceType
  );
  if (formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
    healthInsuranceComboBoxList = filterComboBoxHealthInsuranceTypeWhenExist(
      healthInsuranceComboBoxList
    );
  }
  if (
    formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  ) {
    healthInsuranceComboBoxList = filterComboBoxHealthInsuranceTypeWhenExclusion(
      healthInsuranceComboBoxList,
      formValues.health_insurance_reason_exclusion
    );
  }

  let pensionTypeComboBoxList = _.cloneDeep(comboBoxList.pensionType);

  if (
    !isNotUndefinedAll(
      events,
      formValues,
      ccus_info,
      messages,
      disabledAll,
      comboBoxList
    )
  ) {
    throw new Error('InsuranceInfoForm.jsx function call');
  }
  if (
    !isArrayAll(
      attachDocumentCodes_HealthInsurance,
      attachDocuments_HealthInsurance,
      attachDocumentCodes_Pension,
      attachDocuments_Pension,
      attachDocumentCodes_EmploymentInsurance,
      attachDocuments_EmploymentInsurance,
      attachDocumentCodes_UnemploymentInsurance,
      attachDocuments_UnemploymentInsurance,
      attachDocumentCodes_WorkerCompensation,
      attachDocuments_WorkerCompensation
    )
  ) {
    throw new Error('InsuranceInfoForm.jsx function call');
  }
  if (
    !isFunctionAll(
      events.setValueInsuranceInfo,
      events.setCCUSValuesInsurance,
      events.validate,
      events.inputValueSearch,
      events.uploadFile,
      events.download,
      events.deleteFile
    )
  ) {
    throw new Error('InsuranceInfoForm.jsx function call');
  }

  let hasValueCCUSbtn = false;

  const showRadioValueExistanceExclusion = value => {
    const result = getTextExistanceExclusionFlag(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const showRadioValueExistance = value => {
    const result = getTextExistanceFlag(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const showRadioValueInsuranceReceiving = value => {
    const result = getTextInsuranceReceivingFlag(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const showRadioValueWorkerCompensationType = value => {
    const result = getTextWorkerCompensationType(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const showRadioValuePensionVoluntaryCoverageFlag = value => {
    const result = getTextPensionVoluntaryCoverageFlag(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const ccus_element = key => {
    // console.log('InsuranceInfoForm.jsx ccus_element', key);
    // comboBoxListのIDと突き合わせてccus情報を表示する箇所がある為、comboBoxのデータがなければreturn
    // ※comboBoxのデータはマスタデータの為、存在しないことはないはず
    // BLDE_V2-50226 CCUS事業者IDは削除された場合に、転記情報は表示されない
    if (_.size(comboBoxList) === 0 || disabledAll) {
      return null;
    }
    let val = '';
    if (!isCcusJigyousyaDeleted) {
      if (
        key === 'health_insurance_flag' ||
        key === 'pension_flag' ||
        key === 'worker_compensation_flag' ||
        key === 'employment_insurance_flag' ||
        key === 'const_subscription_flag' ||
        key === 'enterprise_subscription_flag'
      ) {
        val = showRadioValueExistanceExclusion(ccus_info[key]);
      } else if (key === 'worker_compensation_type') {
        val = showRadioValueWorkerCompensationType(ccus_info[key]);
      } else if (key === 'pension_reason_exclusion') {
        // 年金適用除外理由の場合、適用除外理由コードからの日本語を取得して設定する
        val = CcusMasterService.getPensionExclusionReason(
          ccus_info[key],
          comboBoxList.pensionReasonExclusion
        );
      } else if (key === 'employment_insurance_reason_exclusion') {
        // 雇用保険適用除外理由の場合、適用除外理由コードからの日本語を取得して設定する
        val = CcusMasterService.getEmploymentInsExclusionReason(
          ccus_info[key],
          comboBoxList.employmentInsuranceReasonExclusion
        );
      } else if (key === 'health_insurance_reason_exclusion') {
        // 健康保険適用除外理由の場合、適用除外理由コードからの日本語を取得して設定する
        val = CcusMasterService.getHealthInsExclusionReason(
          ccus_info[key],
          comboBoxList.healthInsuranceReasonExclusion
        );
      } else {
        val = ccus_info ? ccus_info[key] : null;
      }
      if (!val) {
        return null;
      }
      hasValueCCUSbtn = true;
      return (
        <CcusLineComponent
          onClick={() => {
            events.setCCUSValuesInsurance(key);
          }}
        >
          {val}
        </CcusLineComponent>
      );
    } else {
      return null;
    }
  };
  // BLDE_V2-50226 CCUS事業者IDは削除された場合に、転記情報は表示されない
  const TitleElement = ({ title, hasCcusComponent = false, noMarginTop }) => (
    <FormListSubHeader
      title={title}
      ccusComponent={
        !disabledAll &&
        hasValueCCUSbtn &&
        hasCcusComponent && (
          <CcusTitleBlock
            onClick={e => {
              e.preventDefault();
              events.showCcusInfoTranscriptionAgreementDialog();
            }}
          />
        )
      }
      noMarginTop={noMarginTop}
    />
  );

  const workerInputTextOnChange = e => {
    events.setValueInsuranceInfo(e.target.name, e.target.value);
  };

  const workerInputTextOnBlur = e => {
    events.validate(e.target.name);
  };

  const showHealthInsuranceType = () => {
    if (
      formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID ||
      formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return true;
    }
    return false;
  };

  const showHealthInsuranceNameInsurer = () => {
    if (
      formValues.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID ||
      isNullOrUndefinedOrEmptyStr(formValues.health_insurance_flag)
    ) {
      return false;
    }
    if (
      formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID
    ) {
      return true;
    }
    // 生活保護受給者以外
    if (
      _.includes(
        [
          'けんぽ適用除外承認済',
          '５人未満個人事業所',
          '常用以外の短時間労働者',
          '日雇労働者',
          '臨時労働者',
          '季節的業務',
          '巡業・興業',
          '臨時的事業',
          '個人事業主と家族従事者',
          '後期高齢者医療対象者',
          'その他',
        ],
        formValues.health_insurance_reason_exclusion
      )
    ) {
      return true;
    }
    return false;
  };

  const renderHealthInsuranceTypeFormSelect = () => {
    if (
      formValues.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      _.includes(
        ['けんぽ適用除外承認済', '後期高齢者医療対象者'],
        formValues.health_insurance_reason_exclusion
      ) &&
      formValues.health_insurance_type !== 'その他'
    ) {
      return (
        <span data-testid='health_insurance_type_text'>
          {formValues.health_insurance_type}
        </span>
      );
    }

    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='health_insurance_type'
            value={
              formValues.health_insurance_type !== null
                ? formValues.health_insurance_type
                : ''
            }
            onChange={e =>
              events.inputValueSearch(
                { ...formValues },
                healthInsuranceComboBoxList,
                deleteControlCode(e.target.value),
                -1,
                {
                  searchKey: 'health_insurance_type',
                  codeKey: 'health_insurance_type_code',
                  targetKey: 'health_insurance_type',
                  blockKey: 'insuranceInfo',
                }
              )
            }
            onBlur={e => {
              if (e.target.value !== formValues.health_insurance_type) {
                events.inputValueSearch(
                  { ...formValues },
                  healthInsuranceComboBoxList,
                  deleteControlCode(e.target.value),
                  -1,
                  {
                    searchKey: 'health_insurance_type',
                    codeKey: 'health_insurance_type_code',
                    targetKey: 'health_insurance_type',
                    blockKey: 'insuranceInfo',
                  }
                );
              }
            }}
          >
            <option value=''>選択してください</option>
            {_.map(healthInsuranceComboBoxList, (item, index) => (
              <option
                key={item.health_insurance_type_code}
                value={item.health_insurance_type}
              >
                {item.health_insurance_type}
              </option>
            ))}
            {formValues.health_insurance_type === 'その他' && (
              <option
                key='0'
                value='その他'
                disabled
                style={{ display: 'none' }}
              >
                その他
              </option>
            )}
          </FormSelect>
        </FormElementContainerItem>
        {formValues.health_insurance_type === 'その他' && (
          <FormElementContainerItem>
            <WorkerInputText
              name='health_insurance_type_other'
              value={formValues.health_insurance_type_other}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElementContainerItem>
        )}
      </FormElementContainer>
    );
  };

  const renderHealthInsuranceTypeSafetyDocItem = () => {
    if (formValues.health_insurance_type !== '生活保護受給者(保険証なし)') {
      return <SafetyDocItemIcon isFormListDefault={true} />;
    }
  };

  const renderEmploymentInsuranceReasonExclusion = () => {
    if (disabledAll) {
      return <span>{formValues.employment_insurance_reason_exclusion}</span>;
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='employment_insurance_reason_exclusion'
            value={
              formValues.employment_insurance_reason_exclusion !== null
                ? formValues.employment_insurance_reason_exclusion
                : ''
            }
            onChange={e =>
              events.inputValueSearch(
                { ...formValues },
                comboBoxList.employmentInsuranceReasonExclusion,
                deleteControlCode(e.target.value),
                -1,
                {
                  searchKey: 'employment_insurance_reason_exclusion',
                  codeKey: 'ccus_employment_insurance_reason_exclusion_code',
                  targetKey: 'employment_insurance_reason_exclusion',
                  blockKey: 'insuranceInfo',
                }
              )
            }
            onBlur={e => {
              if (
                e.target.value !==
                formValues.employment_insurance_reason_exclusion
              ) {
                events.inputValueSearch(
                  { ...formValues },
                  comboBoxList.employmentInsuranceReasonExclusion,
                  deleteControlCode(e.target.value),
                  -1,
                  {
                    searchKey: 'employment_insurance_reason_exclusion',
                    codeKey: 'ccus_employment_insurance_reason_exclusion_code',
                    targetKey: 'employment_insurance_reason_exclusion',
                    blockKey: 'insuranceInfo',
                  }
                );
              }
            }}
          >
            <option value=''>選択してください</option>
            {_.map(
              comboBoxList.employmentInsuranceReasonExclusion,
              (item, index) => (
                <option
                  key={item.ccus_employment_insurance_reason_exclusion_code}
                  value={item.employment_insurance_reason_exclusion}
                >
                  {item.employment_insurance_reason_exclusion}
                </option>
              )
            )}
            {formValues.employment_insurance_reason_exclusion === 'その他' && (
              <option
                key='0'
                value='その他'
                disabled
                style={{ display: 'none' }}
              >
                その他
              </option>
            )}
          </FormSelect>
        </FormElementContainerItem>
        {formValues.employment_insurance_reason_exclusion === 'その他' && (
          <FormElementContainerItem>
            <WorkerInputText
              name='employment_insurance_reason_exclusion_other'
              value={formValues.employment_insurance_reason_exclusion_other}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElementContainerItem>
        )}
      </FormElementContainer>
    );
  };

  const renderEmploymentInsuranceType = () => {
    if (disabledAll) {
      return <span>{formValues.employment_insurance_type}</span>;
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='employment_insurance_type'
            value={
              formValues.employment_insurance_type !== null
                ? formValues.employment_insurance_type
                : ''
            }
            onChange={e =>
              events.inputValueSearch(
                { ...formValues },
                comboBoxList.employmentInsuranceType,
                deleteControlCode(e.target.value),
                -1,
                {
                  searchKey: 'employment_insurance_type',
                  codeKey: 'employment_insurance_type_code',
                  targetKey: 'employment_insurance_type',
                  blockKey: 'insuranceInfo',
                }
              )
            }
            onBlur={e => {
              if (e.target.value !== formValues.employment_insurance_type) {
                events.inputValueSearch(
                  { ...formValues },
                  comboBoxList.employmentInsuranceType,
                  deleteControlCode(e.target.value),
                  -1,
                  {
                    searchKey: 'employment_insurance_type',
                    codeKey: 'employment_insurance_type_code',
                    targetKey: 'employment_insurance_type',
                    blockKey: 'insuranceInfo',
                  }
                );
              }
            }}
          >
            <option value=''>選択してください</option>
            {_.map(comboBoxList.employmentInsuranceType, (item, index) => (
              <option
                key={item.employment_insurance_type_code}
                value={item.employment_insurance_type}
              >
                {item.employment_insurance_type}
              </option>
            ))}
            {formValues.employment_insurance_type === 'その他' && (
              <option
                key='0'
                value='その他'
                disabled
                style={{ display: 'none' }}
              >
                その他
              </option>
            )}
          </FormSelect>
        </FormElementContainerItem>
        {formValues.employment_insurance_type === 'その他' && (
          <FormElementContainerItem>
            <WorkerInputText
              name='employment_insurance_type_other'
              value={formValues.employment_insurance_type_other}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElementContainerItem>
        )}
      </FormElementContainer>
    );
  };

  const showHealthInsuranceExpirationDate = () => {
    if (
      formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID ||
      formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      if (
        formValues.health_insurance_flag ===
          EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
        formValues.health_insurance_reason_exclusion === '生活保護受給者'
      ) {
        return false;
      }
      return true;
    }
    return false;
  };

  const showAttachDocumentsHealthInsurance = () => {
    if (
      formValues.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID ||
      formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID ||
      formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return true;
    }
    return false;
  };

  const showPensionFlag = () => {
    return true;
  };

  const showPensionSpecialReason = () => {
    return true;
  };

  // 年金保険 特段の理由
  const showPensionReasonExclusion = () => {
    if (formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
      return true;
    }
    return false;
  };

  // 年金保険 保険種類
  const showPensionType = () => {
    if (
      formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID ||
      formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return true;
    }
    return false;
  };

  // 年金保険 受給状況
  const showPensionInsuranceReceivingFlag = () => {
    // 本日が60歳になる誕生日(-1日)以降かチェック
    if (isDayBeforeSixtiethBirthday) {
      return true;
    }
    return false;
  };

  // 年金保険 添付書類
  const showAttachDocumentsPension = () => {
    if (
      formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID ||
      formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID ||
      formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return true;
    }
    return false;
  };

  const showEmploymentInsuranceReasonExclusion = () => {
    if (
      formValues.employment_insurance_flag ===
      EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return true;
    }
    return false;
  };

  const showEmploymentInsuranceType = () => {
    if (
      formValues.employment_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID
    ) {
      return true;
    }
    return false;
  };

  const showEmploymentInsuranceInsuredNumber = () => {
    if (
      formValues.employment_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID
    ) {
      return true;
    }
    return false;
  };

  const showPensionInsBizName = () => {
    if (formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
      return true;
    }
    return false;
  };

  const showAttachDocumentsEmploymentInsurance = () => {
    if (
      formValues.employment_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID ||
      formValues.employment_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXIST.ID ||
      formValues.employment_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return true;
    }
    return false;
  };

  const isShowHealthInsuranceExpirationDate = showHealthInsuranceExpirationDate();
  const isShowAttachDocumentsHealthInsurance = showAttachDocumentsHealthInsurance();

  const isShowPensionFlag = showPensionFlag();
  const isShowPensionSpecialReason = showPensionSpecialReason();
  const isShowPensionReasonExclusion = showPensionReasonExclusion();
  const isShowPensionType = showPensionType();
  const isShowPensionInsuranceReceivingFlag = showPensionInsuranceReceivingFlag();
  const isShowAttachDocumentsPension = showAttachDocumentsPension();
  const isShowPensionInsBizName = showPensionInsBizName();

  const isShowEmploymentInsuranceReasonExclusion = showEmploymentInsuranceReasonExclusion();
  const isShowEmploymentInsuranceType = showEmploymentInsuranceType();
  const isShowEmploymentInsuranceInsuredNumber = showEmploymentInsuranceInsuredNumber();
  const isShowAttachDocumentsEmploymentInsurance = showAttachDocumentsEmploymentInsurance();

  // const requireAttachDocumentsHealthInsurance = () => {
  //   if (
  //     formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID ||
  //     formValues.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  //   ) {
  //     if (formValues.health_insurance_reason_exclusion === '生活保護受給者') {
  //       return false;
  //     }
  //     return true;
  //   }
  //   return false;
  // };

  // const isRequiredAttachDocumentsHealthInsurance = requireAttachDocumentsHealthInsurance();

  const renderHealthInsuranceTypeValue = () => {
    if (
      disabledAll ||
      (formValues.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
        formValues.health_insurance_reason_exclusion === '生活保護受給者')
    ) {
      return <span>{formValues.health_insurance_type}</span>;
    }
    return renderHealthInsuranceTypeFormSelect();
  };

  const renderPensionType = () => {
    if (disabledAll) {
      if (
        formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
        isNullOrUndefinedOrEmptyStr(formValues.pension_type) &&
        (!isDayBeforeTwentiethBirthday ||
          (isDayBeforeSixtiethBirthday &&
            formValues.pension_voluntary_coverage_flag !==
              PENSION_VOLUNTARY_COVERAGE_FLAG.COVERED.ID))
      ) {
        return <span>－（国民年金の加入対象外）</span>;
      }
      return <span>{formValues.pension_type}</span>;
    }

    // 加入状況適用除外の時、保険種類は国民年金 既存データで別のパターンは存在しない
    if (formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
      if (formValues.pension_type === '国民年金') {
        return <span>{formValues.pension_type}</span>;
      }
      if (
        isNullOrUndefinedOrEmptyStr(formValues.pension_type) &&
        (isDayBeforeSixtiethBirthday || !isDayBeforeTwentiethBirthday) &&
        formValues.pension_voluntary_coverage_flag !==
          PENSION_VOLUNTARY_COVERAGE_FLAG.COVERED.ID
      ) {
        return <span>－（国民年金の加入対象外）</span>;
      }
    }

    // 加入状況有の時、保険種類は厚生年金 既存データで別のパターンがある場合は、固定表示しない
    if (
      formValues.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID &&
      formValues.pension_type === '厚生年金'
    ) {
      return <span>{formValues.pension_type}</span>;
    }

    return (
      <React.Fragment>
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_type'
              value={
                formValues.pension_type !== null ? formValues.pension_type : ''
              }
              onChange={e =>
                events.inputValueSearch(
                  { ...formValues },
                  pensionTypeComboBoxList,
                  deleteControlCode(e.target.value),
                  -1,
                  {
                    searchKey: 'pension_type',
                    codeKey: 'pension_type_code',
                    targetKey: 'pension_type',
                    blockKey: 'insuranceInfo',
                  }
                )
              }
              onBlur={e => {
                if (e.target.value !== formValues.pension_type) {
                  events.inputValueSearch(
                    { ...formValues },
                    pensionTypeComboBoxList,
                    deleteControlCode(e.target.value),
                    -1,
                    {
                      searchKey: 'pension_type',
                      codeKey: 'pension_type_code',
                      targetKey: 'pension_type',
                      blockKey: 'insuranceInfo',
                    }
                  );
                }
              }}
            >
              <option value=''>
                {pensionTypeComboBoxList.length > 0
                  ? `選択してください`
                  : `－（国民年金の加入対象外）`}
              </option>
              {_.map(pensionTypeComboBoxList, item => (
                <option key={item.pension_type_code} value={item.pension_type}>
                  {item.pension_type}
                </option>
              ))}
              {formValues.pension_type === 'その他' && (
                <option
                  key='0'
                  value='その他'
                  disabled
                  style={{ display: 'none' }}
                >
                  その他
                </option>
              )}
            </FormSelect>
          </FormElementContainerItem>
          {formValues.pension_type === 'その他' && (
            <FormElementContainerItem>
              <WorkerInputText
                name='pension_type_other'
                value={formValues.pension_type_other}
                messages={messages}
                disabled={disabledAll}
                maxLength={255}
                onChange={workerInputTextOnChange}
                onBlur={workerInputTextOnBlur}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      </React.Fragment>
    );
  };

  const renderPensionReasonExclusion = () => {
    if (disabledAll) {
      return <span>{formValues.pension_reason_exclusion}</span>;
    }

    return (
      <React.Fragment>
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_reason_exclusion'
              value={
                formValues.pension_reason_exclusion !== null
                  ? formValues.pension_reason_exclusion
                  : ''
              }
              onChange={e =>
                events.inputValueSearch(
                  { ...formValues },
                  comboBoxList.pensionReasonExclusion,
                  deleteControlCode(e.target.value),
                  -1,
                  {
                    searchKey: 'pension_reason_exclusion',
                    codeKey: 'ccus_pension_reason_exclusion_code',
                    targetKey: 'pension_reason_exclusion',
                    blockKey: 'insuranceInfo',
                  }
                )
              }
              onBlur={e => {
                if (e.target.value !== formValues.pension_reason_exclusion) {
                  events.inputValueSearch(
                    { ...formValues },
                    comboBoxList.pensionReasonExclusion,
                    deleteControlCode(e.target.value),
                    -1,
                    {
                      searchKey: 'pension_reason_exclusion',
                      codeKey: 'ccus_pension_reason_exclusion_code',
                      targetKey: 'pension_reason_exclusion',
                      blockKey: 'insuranceInfo',
                    }
                  );
                }
              }}
            >
              <option value=''>選択してください</option>
              {_.map(comboBoxList.pensionReasonExclusion, item => (
                <option
                  key={item.ccus_pension_reason_exclusion_code}
                  value={item.pension_reason_exclusion}
                >
                  {item.pension_reason_exclusion}
                </option>
              ))}
              {formValues.pension_reason_exclusion === 'その他' && (
                <option
                  key='0'
                  value='その他'
                  disabled
                  style={{ display: 'none' }}
                >
                  その他
                </option>
              )}
            </FormSelect>
          </FormElementContainerItem>
          {formValues.pension_reason_exclusion === 'その他' && (
            <FormElementContainerItem>
              <WorkerInputText
                name='pension_reason_exclusion_other'
                value={formValues.pension_reason_exclusion_other}
                messages={messages}
                disabled={disabledAll}
                maxLength={255}
                onChange={workerInputTextOnChange}
                onBlur={workerInputTextOnBlur}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      </React.Fragment>
    );
  };

  // 加入状況が無(未加入)の場合、未加入でも良いと証明する書類を期待するメッセージを表示
  const renderDocumentationMessage = name => {
    return (
      !disabledAll &&
      formValues[name] === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID &&
      messageUtility.getMessage('I-000-135')
    );
  };

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix InsuranceInfoForm'>
      {ccusDescription}
      {attentionBox}
      <FormList>
        <div className='InsuranceInfoForm__manual-download form-list-default__ExceptionalItems'>
          <Description type='primary'>
            社会保険の登録方法に関するマニュアルは
            <span
              className='clickable-text'
              onClick={() => downloadWorkerInsuranceManual()}
              data-testid='worker_insurance_manual_download_link'
            >
              こちら
            </span>
            からダウンロードできます。
          </Description>
        </div>
        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <InsuranceDocumentMyNumberCardWarning />
          </div>
        )}
        <TitleElement
          title='健康保険'
          hasCcusComponent={true}
          noMarginTop={true}
        />
        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に健康保険証をご用意頂き「社会保険に関するマニュアル」を参照しながら、ご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='health_insurance_flag'
        >
          <FormElement
            ccusComponent={ccus_element('health_insurance_flag')}
            validate={messages.health_insurance_flag}
            info={renderDocumentationMessage('health_insurance_flag')}
          >
            {disabledAll ? (
              <WorkerRadioText
                name='health_insurance_flag'
                value={showRadioValueExistanceExclusion(
                  formValues.health_insurance_flag
                )}
                disabled={true}
              />
            ) : (
              <React.Fragment>
                {_.map(EXISTANCE_EXCLUSION_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`health_insurance_flag${String(i)}`}
                      label={item.TEXT}
                      name='health_insurance_flag'
                      value={item.ID}
                      events={events}
                      checked={formValues.health_insurance_flag === item.ID}
                      disabled={false}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <SpecialReasonFormItem
          formValues={formValues}
          targetPrefix={'health_insurance'}
          comboBoxList={comboBoxList}
          events={events}
          messages={messages}
          disabledAll={disabledAll}
          workerInputTextOnChange={workerInputTextOnChange}
          workerInputTextOnBlur={workerInputTextOnBlur}
          ccusElement={ccus_element}
        />

        {formValues.health_insurance_flag ===
          EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID && (
          <FormListItem
            label='適用除外理由'
            data-testid='health_insurance_reason_exclusion'
          >
            <FormElement
              ccusComponent={ccus_element('health_insurance_reason_exclusion')}
              validate={messages.health_insurance_reason_exclusion}
              info={
                !disabledAll &&
                formValues.health_insurance_reason_exclusion === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {!disabledAll ? (
                <FormElementContainer>
                  <FormElementContainerItem>
                    <FormSelect
                      name='health_insurance_reason_exclusion'
                      value={
                        formValues.health_insurance_reason_exclusion !== null
                          ? formValues.health_insurance_reason_exclusion
                          : ''
                      }
                      onChange={e =>
                        events.inputValueSearch(
                          { ...formValues },
                          comboBoxList.healthInsuranceReasonExclusion,
                          deleteControlCode(e.target.value),
                          -1,
                          {
                            searchKey: 'health_insurance_reason_exclusion',
                            codeKey:
                              'ccus_health_insurance_reason_exclusion_code',
                            targetKey: 'health_insurance_reason_exclusion',
                            blockKey: 'insuranceInfo',
                          }
                        )
                      }
                      onBlur={e => {
                        if (
                          e.target.value !==
                            formValues.health_insurance_reason_exclusion &&
                          !(
                            e.target.value === '' &&
                            formValues.health_insurance_reason_exclusion ===
                              null
                          )
                        ) {
                          events.inputValueSearch(
                            { ...formValues },
                            comboBoxList.healthInsuranceReasonExclusion,
                            deleteControlCode(e.target.value),
                            -1,
                            {
                              searchKey: 'health_insurance_reason_exclusion',
                              codeKey:
                                'ccus_health_insurance_reason_exclusion_code',
                              targetKey: 'health_insurance_reason_exclusion',
                              blockKey: 'insuranceInfo',
                            }
                          );
                        }
                      }}
                    >
                      <option value=''>選択してください</option>
                      {_.map(
                        comboBoxList.healthInsuranceReasonExclusion,
                        item => (
                          <option
                            key={
                              item.ccus_health_insurance_reason_exclusion_code
                            }
                            value={item.health_insurance_reason_exclusion}
                          >
                            {item.health_insurance_reason_exclusion}
                          </option>
                        )
                      )}
                      {formValues.health_insurance_reason_exclusion ===
                        'その他' && (
                        <option
                          key='0'
                          value='その他'
                          disabled
                          style={{ display: 'none' }}
                        >
                          その他
                        </option>
                      )}
                    </FormSelect>
                  </FormElementContainerItem>
                  {formValues.health_insurance_reason_exclusion ===
                    'その他' && (
                    <FormElementContainerItem>
                      <WorkerInputText
                        name='health_insurance_reason_exclusion_other'
                        value={
                          formValues.health_insurance_reason_exclusion_other
                        }
                        messages={messages}
                        disabled={disabledAll}
                        maxLength={255}
                        onChange={workerInputTextOnChange}
                        onBlur={workerInputTextOnBlur}
                      />
                    </FormElementContainerItem>
                  )}
                </FormElementContainer>
              ) : (
                <span>{formValues.health_insurance_reason_exclusion}</span>
              )}
            </FormElement>
          </FormListItem>
        )}

        {showHealthInsuranceType() && (
          <FormListItem
            label='保険種類'
            safetyDocItem={renderHealthInsuranceTypeSafetyDocItem()}
            data-testid='health_insurance_type'
          >
            <FormElement
              ccusComponent={ccus_element('health_insurance_type')}
              validate={messages.health_insurance_type}
              info={
                !disabledAll &&
                formValues.health_insurance_type === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderHealthInsuranceTypeValue()}
            </FormElement>
          </FormListItem>
        )}

        {showHealthInsuranceNameInsurer() && (
          <FormListItem
            label='保険者名'
            data-testid='health_insurance_name_insurer'
          >
            <FormElement
              ccusComponent={ccus_element('health_insurance_name_insurer')}
              validate={messages.health_insurance_name_insurer}
            >
              <WorkerInputText
                name='health_insurance_name_insurer'
                value={formValues.health_insurance_name_insurer}
                messages={messages}
                disabled={disabledAll}
                maxLength={255}
                onChange={workerInputTextOnChange}
                onBlur={workerInputTextOnBlur}
              />
            </FormElement>
          </FormListItem>
        )}
        {isShowHealthInsuranceExpirationDate && (
          <FormListItem
            label='有効期限'
            data-testid='health_insurance_expiration_date'
          >
            {(!disabledAll || formValues.health_insurance_expiration_date) && (
              <DateInput
                dateString={formValues.health_insurance_expiration_date}
                disabled={disabledAll}
                onChangeValue={val =>
                  events.setValueInsuranceInfo(
                    'health_insurance_expiration_date',
                    val
                  )
                }
                isPreview={disabledAll}
                ccusComponent={ccus_element('health_insurance_expiration_date')}
                message={messages.health_insurance_expiration_date}
                warning={wrapperValidExpirationDate(
                  formValues.health_insurance_expiration_date,
                  null,
                  true,
                  messages.health_insurance_expiration_date
                )}
                jpDelimiterChar={true}
                onBlur={() =>
                  workerInputTextOnBlur({
                    target: { name: 'health_insurance_expiration_date' },
                  })
                }
                info={
                  !disabledAll &&
                  `健康保険証に有効期限の記載がある場合は記載をしてください。`
                }
              />
            )}
          </FormListItem>
        )}

        {isShowAttachDocumentsHealthInsurance && (
          <FormListItem
            label='添付書類'
            data-testid='attachDocuments_HealthInsurance'
          >
            <FormElement>
              <AttachDocument
                requireConfirm={true}
                companyDocuments={attachDocuments_HealthInsurance}
                documentCodes={attachDocumentCodes_HealthInsurance}
                itemName=''
                events={events}
                readOnly={disabledAll}
                indexId='健康保険'
                styleWide={true}
                isFormListDefault={true}
              />
            </FormElement>
          </FormListItem>
        )}

        <TitleElement title='年金保険' />
        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に年金保険の各種通知書・加入証明書などをご用意頂き「社会保険に関するマニュアル」を参照しながらご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        {isShowPensionFlag && (
          <FormListItem
            label='加入状況'
            safetyDocItem={true}
            data-testid='pension_flag'
          >
            <FormElement
              ccusComponent={ccus_element('pension_flag')}
              info={renderDocumentationMessage('pension_flag')}
            >
              {disabledAll ? (
                <WorkerRadioText
                  name='pension_flag'
                  value={showRadioValueExistanceExclusion(
                    formValues.pension_flag
                  )}
                  disabled={true}
                />
              ) : (
                <React.Fragment>
                  {_.map(EXISTANCE_EXCLUSION_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`pension_flag${String(i)}`}
                        label={item.TEXT}
                        name='pension_flag'
                        value={item.ID}
                        events={events}
                        checked={formValues.pension_flag === item.ID}
                        disabled={false}
                      />
                    );
                  })}
                </React.Fragment>
              )}
            </FormElement>
          </FormListItem>
        )}

        {isShowPensionSpecialReason && (
          <SpecialReasonFormItem
            formValues={formValues}
            targetPrefix={'pension'}
            comboBoxList={comboBoxList}
            events={events}
            messages={messages}
            disabledAll={disabledAll}
            workerInputTextOnChange={workerInputTextOnChange}
            workerInputTextOnBlur={workerInputTextOnBlur}
            ccusElement={ccus_element}
          />
        )}

        {isShowPensionReasonExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='pension_reason_exclusion'
          >
            <FormElement
              ccusComponent={ccus_element('pension_reason_exclusion')}
              info={
                !disabledAll &&
                formValues.pension_reason_exclusion === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderPensionReasonExclusion()}
            </FormElement>
          </FormListItem>
        )}
        {isShowPensionVoluntaryCoverageFlag && (
          <FormListItem
            label='任意加入'
            safetyDocItem={true}
            data-testid='pension_voluntary_coverage_flag'
          >
            <FormElement
              ccusComponent={ccus_element('pension_voluntary_coverage_flag')}
            >
              {disabledAll ? (
                <WorkerRadioText
                  name='pension_voluntary_coverage_flag'
                  value={showRadioValuePensionVoluntaryCoverageFlag(
                    formValues.pension_voluntary_coverage_flag
                  )}
                  disabled={true}
                />
              ) : (
                <React.Fragment>
                  {_.map(PENSION_VOLUNTARY_COVERAGE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`pension_voluntary_coverage_flag${String(i)}`}
                        label={item.TEXT}
                        name='pension_voluntary_coverage_flag'
                        value={item.ID}
                        events={events}
                        checked={
                          formValues.pension_voluntary_coverage_flag === item.ID
                        }
                        disabled={false}
                      />
                    );
                  })}
                </React.Fragment>
              )}
            </FormElement>
          </FormListItem>
        )}
        {isShowPensionType && (
          <FormListItem
            label='保険種類'
            safetyDocItem={true}
            data-testid='pension_type'
          >
            <FormElement
              ccusComponent={ccus_element('pension_type')}
              info={
                !disabledAll &&
                formValues.pension_type === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderPensionType()}
            </FormElement>
          </FormListItem>
        )}
        {isShowPensionInsBizName && (
          <FormListItem
            label='厚生年金事業所名'
            data-testid='pension_ins_biz_name'
          >
            <FormElement>
              <WorkerInputText
                name='pension_ins_biz_name'
                value={formValues.pension_ins_biz_name}
                messages={messages}
                disabled={disabledAll}
                maxLength={20}
                onChange={workerInputTextOnChange}
                onBlur={workerInputTextOnBlur}
              />
            </FormElement>
          </FormListItem>
        )}
        {isShowPensionExpirationDate && (
          <FormListItem
            label='有効期限'
            data-testid='pension_insurance_expiration_date'
          >
            {(!disabledAll || formValues.pension_insurance_expiration_date) && (
              <DateInput
                dateString={formValues.pension_insurance_expiration_date}
                disabled={disabledAll}
                onChangeValue={val =>
                  events.setValueInsuranceInfo(
                    'pension_insurance_expiration_date',
                    val
                  )
                }
                isPreview={disabledAll}
                ccusComponent={ccus_element(
                  'pension_insurance_expiration_date'
                )}
                message={messages.pension_insurance_expiration_date}
                warning={wrapperValidExpirationDate(
                  formValues.pension_insurance_expiration_date,
                  null,
                  true,
                  messages.pension_insurance_expiration_date
                )}
                jpDelimiterChar={true}
                onBlur={() =>
                  workerInputTextOnBlur({
                    target: { name: 'pension_insurance_expiration_date' },
                  })
                }
                info={
                  !disabledAll &&
                  `加入証明書として健康保険証を添付される場合は、健康保険証の有効期限を記載してください。`
                }
              />
            )}
          </FormListItem>
        )}
        {isShowPensionInsuranceReceivingFlag && (
          <FormListItem
            label='受給状況'
            safetyDocItem={true}
            data-testid='pension_insurance_receiving_flag'
          >
            <FormElement
              ccusComponent={ccus_element('pension_insurance_receiving_flag')}
            >
              {disabledAll ? (
                <WorkerRadioText
                  name='pension_insurance_receiving_flag'
                  value={showRadioValueInsuranceReceiving(
                    formValues.pension_insurance_receiving_flag
                  )}
                  disabled={true}
                />
              ) : (
                <React.Fragment>
                  {_.map(INSURANCE_RECEIVING_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`pension_insurance_receiving_flag${String(i)}`}
                        label={item.TEXT}
                        name='pension_insurance_receiving_flag'
                        value={item.ID}
                        events={events}
                        checked={
                          formValues.pension_insurance_receiving_flag ===
                          item.ID
                        }
                        disabled={false}
                      />
                    );
                  })}
                </React.Fragment>
              )}
            </FormElement>
          </FormListItem>
        )}

        {isShowAttachDocumentsPension && (
          <FormListItem label='添付書類' data-testid='attachDocuments_Pension'>
            <FormElement>
              <AttachDocument
                companyDocuments={attachDocuments_Pension}
                documentCodes={attachDocumentCodes_Pension}
                itemName=''
                events={events}
                readOnly={disabledAll}
                indexId='年金'
                styleWide={true}
                isFormListDefault={true}
              />
            </FormElement>
          </FormListItem>
        )}

        <TitleElement title='雇用保険' />

        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に雇用保険被保険者証をご用意頂き「社会保険に関するマニュアル」を参照しながらご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='employment_insurance_flag'
        >
          <FormElement
            ccusComponent={ccus_element('employment_insurance_flag')}
            validate={messages.employment_insurance_flag}
            info={renderDocumentationMessage('employment_insurance_flag')}
          >
            {disabledAll ? (
              <WorkerRadioText
                name='employment_insurance_flag'
                value={showRadioValueExistanceExclusion(
                  formValues.employment_insurance_flag
                )}
                disabled={true}
              />
            ) : (
              <React.Fragment>
                {_.map(EXISTANCE_EXCLUSION_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`employment_insurance_flag${String(i)}`}
                      label={item.TEXT}
                      name='employment_insurance_flag'
                      value={item.ID}
                      events={events}
                      checked={formValues.employment_insurance_flag === item.ID}
                      disabled={false}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <SpecialReasonFormItem
          formValues={formValues}
          targetPrefix={'employment_insurance'}
          comboBoxList={comboBoxList}
          events={events}
          messages={messages}
          disabledAll={disabledAll}
          workerInputTextOnChange={workerInputTextOnChange}
          workerInputTextOnBlur={workerInputTextOnBlur}
          ccusElement={ccus_element}
        />

        {isShowEmploymentInsuranceReasonExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='employment_insurance_reason_exclusion'
          >
            <FormElement
              ccusComponent={ccus_element(
                'employment_insurance_reason_exclusion'
              )}
              info={
                !disabledAll &&
                formValues.employment_insurance_reason_exclusion ===
                  'その他' && <AdditionalInfoAboutOthers />
              }
            >
              {renderEmploymentInsuranceReasonExclusion()}
            </FormElement>
          </FormListItem>
        )}

        {isShowEmploymentInsuranceType && (
          <FormListItem
            label='被保険者種類'
            safetyDocItem={<SafetyDocItemIcon isFormListDefault={true} />}
            data-testid='employment_insurance_type'
          >
            <FormElement
              ccusComponent={ccus_element('employment_insurance_type')}
              validate={messages.employment_insurance_type}
              info={
                !disabledAll &&
                formValues.employment_insurance_type === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderEmploymentInsuranceType()}
            </FormElement>
          </FormListItem>
        )}

        {isShowEmploymentInsuranceInsuredNumber && (
          <FormListItem
            label='被保険者番号'
            safetyDocItem={true}
            data-testid='employment_insurance_insured_number'
          >
            <FormElement
              validate={messages.employment_insurance_insured_number}
            >
              <WorkerInputText
                name='employment_insurance_insured_number'
                value={formValues.employment_insurance_insured_number}
                messages={messages}
                disabled={disabledAll}
                maxLength={20}
                onChange={workerInputTextOnChange}
                onBlur={workerInputTextOnBlur}
              />
            </FormElement>
          </FormListItem>
        )}

        {isShowAttachDocumentsEmploymentInsurance && (
          <FormListItem
            label='添付書類'
            data-testid='attachDocuments_EmploymentInsurance'
          >
            <FormElement>
              <AttachDocument
                companyDocuments={attachDocuments_EmploymentInsurance}
                documentCodes={attachDocumentCodes_EmploymentInsurance}
                itemName=''
                events={events}
                readOnly={disabledAll}
                indexId='雇用保険'
                styleWide={true}
                isFormListDefault={true}
              />
            </FormElement>
          </FormListItem>
        )}

        <TitleElement title='その他伝達事項など' />

        <FormListItem label='メモ'>
          <FormElement
            info={
              !disabledAll &&
              '健康保険・年金・雇用保険の加入状況に関して、他に伝達すべき事項があればこちらに記入してください。'
            }
          >
            {disabledAll ? (
              <div className='form-list__textarea--detail'>
                <span>{formValues.memo}</span>
              </div>
            ) : (
              <textarea
                name='memo'
                value={formValues.memo}
                maxLength={500}
                onChange={workerInputTextOnChange}
              />
            )}
          </FormElement>
        </FormListItem>

        <TitleElement title='退職金共済' />

        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              <React.Fragment>
                <div className='bold'>ご注意</div>
                建退共と中退共は同時加入が行えません。
                <br />
                その他退職金共済制度は、建退共および中退共と同時加入できるものを登録してください。
              </React.Fragment>
            </Description>
          </div>
        )}
        <FormListItem label='建退共加入状況' safetyDocItem={true}>
          <FormElement ccusComponent={ccus_element('const_subscription_flag')}>
            {disabledAll ? (
              <WorkerRadioText
                name='const_subscription_flag'
                value={showRadioValueExistance(
                  formValues.const_subscription_flag
                )}
                disabled={true}
              />
            ) : (
              <React.Fragment>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`const_subscription_flag${String(i)}`}
                      label={item.TEXT}
                      name='const_subscription_flag'
                      value={item.ID}
                      events={events}
                      checked={formValues.const_subscription_flag === item.ID}
                      disabled={false}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='建退共被共済者番号'>
          <FormElement validate={messages.const_number}>
            <WorkerInputText
              name='const_number'
              value={formValues.const_number}
              messages={messages}
              disabled={disabledAll}
              maxLength={20}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='中退共加入状況' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccus_element('enterprise_subscription_flag')}
          >
            {disabledAll ? (
              <WorkerRadioText
                name='enterprise_subscription_flag'
                value={showRadioValueExistance(
                  formValues.enterprise_subscription_flag
                )}
                disabled={true}
              />
            ) : (
              <React.Fragment>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`enterprise_subscription_flag${String(i)}`}
                      label={item.TEXT}
                      name='enterprise_subscription_flag'
                      value={item.ID}
                      events={events}
                      checked={
                        formValues.enterprise_subscription_flag === item.ID
                      }
                      disabled={false}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='中退共契約者番号'>
          <FormElement
            ccusComponent={ccus_element('enterprise_agreement_number')}
            validate={messages.enterprise_agreement_number}
          >
            <WorkerInputText
              name='enterprise_agreement_number'
              value={formValues.enterprise_agreement_number}
              messages={messages}
              disabled={disabledAll}
              maxLength={20}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='中退共被共済者番号'>
          <FormElement validate={messages.enterprise_insured_number}>
            <WorkerInputText
              name='enterprise_insured_number'
              value={formValues.enterprise_insured_number}
              messages={messages}
              disabled={disabledAll}
              maxLength={20}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='その他退職金共済制度加入状況' safetyDocItem={true}>
          <FormElement>
            {disabledAll ? (
              <WorkerRadioText
                name='other_subscription_flag'
                value={showRadioValueExistance(
                  formValues.other_subscription_flag
                )}
                disabled={true}
              />
            ) : (
              <React.Fragment>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`other_subscription_flag${String(i)}`}
                      label={item.TEXT}
                      name='other_subscription_flag'
                      value={item.ID}
                      events={events}
                      checked={formValues.other_subscription_flag === item.ID}
                      disabled={false}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='その他退職金共済制度名称'>
          <FormElement>
            <WorkerInputText
              name='other_subscription_name'
              value={formValues.other_subscription_name}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='添付書類'>
          <FormElement>
            <AttachDocument
              companyDocuments={attachDocuments_UnemploymentInsurance}
              documentCodes={attachDocumentCodes_UnemploymentInsurance}
              itemName=''
              events={events}
              readOnly={disabledAll}
              indexId='退職金共済'
              styleWide={true}
              isFormListDefault={true}
            />
          </FormElement>
        </FormListItem>

        <TitleElement title='労災保険特別加入' />

        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              <React.Fragment>
                中小事業主（労働者数300人以下）や一人親方の場合で、労災保険の特別加入制度（※）に加入済みの方は入力してください。
                <br />
                法人の場合は、加入状況[無]を選択してください。
                <br />
                ※
                中小事業主（労働者数300人以下）や一人親方に対して特別に任意加入が認められた労災保険の事です。
                <br />
                労働者向けの一般的な労災保険ではありませんので、ご注意ください。
              </React.Fragment>
            </Description>
          </div>
        )}
        <FormListItem label='加入状況'>
          <FormElement ccusComponent={ccus_element('worker_compensation_flag')}>
            {disabledAll ? (
              <WorkerRadioText
                name='worker_compensation_flag'
                value={showRadioValueExistance(
                  formValues.worker_compensation_flag
                )}
                disabled={true}
              />
            ) : (
              <React.Fragment>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`worker_compensation_flag${String(i)}`}
                      label={item.TEXT}
                      name='worker_compensation_flag'
                      value={item.ID}
                      events={events}
                      checked={formValues.worker_compensation_flag === item.ID}
                      disabled={false}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='労災保険種類' safetyDocItem={true}>
          <FormElement ccusComponent={ccus_element('worker_compensation_type')}>
            {disabledAll ? (
              <WorkerRadioText
                name='worker_compensation_type'
                value={showRadioValueWorkerCompensationType(
                  formValues.worker_compensation_type
                )}
                disabled={true}
              />
            ) : (
              <React.Fragment>
                {_.map(WORKER_COMPENSATION_TYPE, (item, i) => {
                  return (
                    <FormRadio
                      key={`worker_compensation_type${String(i)}`}
                      label={item.TEXT}
                      name='worker_compensation_type'
                      value={item.ID}
                      events={events}
                      checked={formValues.worker_compensation_type === item.ID}
                      disabled={false}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='添付書類'>
          <FormElement>
            <AttachDocument
              companyDocuments={attachDocuments_WorkerCompensation}
              documentCodes={attachDocumentCodes_WorkerCompensation}
              itemName=''
              events={events}
              readOnly={disabledAll}
              indexId='労災保険特別加入'
              styleWide={true}
              isFormListDefault={true}
            />
          </FormElement>
        </FormListItem>
        {!disabledAll && (
          <div className='form-list__qr-message'>
            ※QRコードは(株)デンソーウェーブの登録商標です。
          </div>
        )}
      </FormList>
    </div>
  );
};

const SpecialReasonFormItem = ({
  formValues,
  targetPrefix,
  comboBoxList,
  events,
  messages,
  disabledAll,
  workerInputTextOnChange,
  workerInputTextOnBlur,
  ccusElement,
}) => {
  if (
    formValues[`${targetPrefix}_flag`] !== EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID
  ) {
    return null;
  }
  // targetPrefix = ['health_insurance', 'pension', 'employment_insurance']
  const specialReasonName = `${targetPrefix}_special_reason`;
  const specialReasonOtherName = `${targetPrefix}_special_reason_other`;
  const specialReasonExpectedDateOfEntryName = `${targetPrefix}_expected_date_of_entry`;

  const specialReasonDataTestId = specialReasonName;
  // const specialReasonOtherDataTestId = specialReasonOtherName;
  const specialReasonExpectedDateOfEntryDataTestId = specialReasonExpectedDateOfEntryName;

  const specialReasonValue =
    formValues[`${targetPrefix}_special_reason`] !== null
      ? formValues[`${targetPrefix}_special_reason`]
      : '';
  const specialReasonOtherValue =
    formValues[`${targetPrefix}_special_reason_other`];

  const validateHealthInsuranceSpecialReason =
    messages[`${targetPrefix}_special_reason`];

  const getTargetCombobox = () => {
    switch (targetPrefix) {
      case 'health_insurance':
      case 'pension':
        return _.map(comboBoxList.specialReason, item => ({
          ...item,
          hidden: item.special_reason_code === '2', // '現場入場時点で６０歳以上で厚生年金保険に未加入'
        }));
      case 'employment_insurance':
        return _.filter(comboBoxList.specialReason, item => {
          return item.special_reason_code !== '2'; // '現場入場時点で６０歳以上で厚生年金保険に未加入'
        });
      default:
        return [];
    }
  };
  const targetCombobox = getTargetCombobox();

  return (
    <React.Fragment>
      <FormListItem label='特段の理由' data-testid={specialReasonDataTestId}>
        <FormElement validate={validateHealthInsuranceSpecialReason}>
          {!disabledAll ? (
            <FormElementContainer>
              <FormElementContainerItem>
                <FormSelect
                  name={specialReasonName}
                  value={specialReasonValue}
                  onChange={e =>
                    events.inputValueSearch(
                      { ...formValues },
                      targetCombobox,
                      deleteControlCode(e.target.value),
                      -1,
                      {
                        searchKey: specialReasonName,
                        codeKey: '',
                        targetKey: specialReasonName,
                        blockKey: 'insuranceInfo',
                      }
                    )
                  }
                  onBlur={e => {
                    if (e.target.value !== formValues[specialReasonName]) {
                      events.inputValueSearch(
                        { ...formValues },
                        targetCombobox,
                        deleteControlCode(e.target.value),
                        -1,
                        {
                          searchKey: specialReasonName,
                          codeKey: '',
                          targetKey: specialReasonName,
                          blockKey: 'insuranceInfo',
                        }
                      );
                    }
                    workerInputTextOnBlur(e);
                  }}
                >
                  <option value=''>選択してください</option>
                  {_.map(targetCombobox, item => {
                    if (
                      item['hidden'] &&
                      specialReasonValue !== item[`special_reason`]
                    ) {
                      //remove hidden option if not choose
                      return;
                    }
                    return (
                      <option
                        key={item[`special_reason_code`]}
                        value={item[`special_reason`]}
                        hidden={item['hidden']}
                        disabled={item['hidden']}
                      >
                        {item[`special_reason`]}
                      </option>
                    );
                  })}
                  <option key='0' value='その他'>
                    その他
                  </option>
                </FormSelect>
              </FormElementContainerItem>
              {formValues[`${specialReasonName}`] === 'その他' && (
                <FormElementContainerItem>
                  <WorkerInputText
                    name={specialReasonOtherName}
                    value={specialReasonOtherValue}
                    messages={messages}
                    disabled={disabledAll}
                    maxLength={255}
                    onChange={workerInputTextOnChange}
                    onBlur={workerInputTextOnBlur}
                  />
                </FormElementContainerItem>
              )}
            </FormElementContainer>
          ) : (
            <span>{specialReasonValue}</span>
          )}
        </FormElement>
      </FormListItem>

      {formValues[`${specialReasonName}`] ===
        '加入手続き中(確実に加入見込みあり)' && (
        <FormListItem
          label='加入予定年月'
          data-testid={specialReasonExpectedDateOfEntryDataTestId}
        >
          {(!disabledAll ||
            formValues[specialReasonExpectedDateOfEntryName]) && (
            <DateInputYearMonth
              dateString={formValues[specialReasonExpectedDateOfEntryName]}
              disabled={disabledAll}
              onChangeValue={val =>
                events.setValueInsuranceInfo(
                  specialReasonExpectedDateOfEntryName,
                  val
                )
              }
              isPreview={disabledAll}
              ccusComponent={ccusElement(specialReasonExpectedDateOfEntryName)}
              message={messages[specialReasonExpectedDateOfEntryName]}
              jpDelimiterChar={true}
              onBlur={() =>
                workerInputTextOnBlur({
                  target: {
                    name: specialReasonExpectedDateOfEntryName,
                  },
                })
              }
            />
          )}
        </FormListItem>
      )}
    </React.Fragment>
  );
};

export default InsuranceInfoForm;



// WEBPACK FOOTER //
// ./src/components/worker/form/InsuranceInfoForm.jsx